import { FIELD_PRIMITIVE__bool } from '@shared/dto/generation/graph_invoke/_fields/_primitives/FIELD_PRIMITIVE__bool';
import { ENUM__dto_class_name } from '@shared/serialization/ENUM__dto_class_name';
import { ENUM__rembg_model } from '../../_enums/ENUM__rembg_model';
import { ENUM__field_store_interaction } from '../../_fields/_base/_enums/ENUM__field_store_interaction';
import { FIELD_PRIMITIVE__string_enum } from '../../_fields/_primitives/string/FIELD_PRIMITIVE__string_enum';
import { ENUM__image_asset_category } from '../../_fields/ENUM__image_asset_category';
import { FIELD__image_asset } from '../../_fields/image/FIELD__image_asset';
import { ENUM__field_role } from '../_base/ENUM__field_role';
import { ENUM__invocation_type } from '../_base/ENUM__invocation_type';
import { INVOCATION__base } from '../_base/INVOCATION__base';

export class INVOCATION_VISION_ML__rembg extends INVOCATION__base {
  /*
   * STATIC FIELDS
   */

  static _class_name_static = ENUM__dto_class_name.INVOCATION_VISION_ML__REMBG;

  /*
   * FIELDS
   */
  @FIELD__image_asset.init_as_input_transform_none({ category: ENUM__image_asset_category.IMAGE })
  image!: FIELD__image_asset;

  @FIELD_PRIMITIVE__string_enum.register_input__enum(ENUM__rembg_model.U2NET, ENUM__rembg_model, {
    field_role: ENUM__field_role.MODEL_NAME,
    store__interaction: ENUM__field_store_interaction.READ_AND_WRITE,
  })
  model_type!: FIELD_PRIMITIVE__string_enum;

  @FIELD_PRIMITIVE__bool.init_as_input({ value: false }, { field_role: '🎛️ Alpha Matting' })
  alpha_matting!: FIELD_PRIMITIVE__bool;

  /*
   *
   */

  @FIELD__image_asset.init_as_output({ category: ENUM__image_asset_category.IMAGE })
  out__image!: FIELD__image_asset;
  /*
   * METHODS
   */

  constructor() {
    super(ENUM__invocation_type.VISION_ML__REMBG);
  }

  post_init() {
    super.post_init();

    let model_range = [ENUM__rembg_model.U2NET, ENUM__rembg_model.U2NETP, ENUM__rembg_model.U2NET_HUMAN_SEG];
    this.model_type.set_value_range(model_range);
  }
}
